import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

export default function BillingSuccessPage() {
  const [status, setStatus] = useState('checking');
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    if (!sessionId) {
      setStatus('error');
      return;
    }
    pollStatus(sessionId, 0);
  }, []);

  const pollStatus = async (sessionId, attempt) => {
    if (attempt >= 5) {
      setStatus('timeout');
      return;
    }
    try {
      const API = process.env.REACT_APP_BACKEND_URL || '';
      const resp = await fetch(`${API}/api/billing/status/${sessionId}`);
      const data = await resp.json();
      setPaymentData(data);

      if (data.payment_status === 'paid') {
        setStatus('success');
      } else if (data.status === 'expired') {
        setStatus('expired');
      } else {
        setTimeout(() => pollStatus(sessionId, attempt + 1), 2000);
      }
    } catch {
      setTimeout(() => pollStatus(sessionId, attempt + 1), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <Navbar />
      <main className="max-w-md mx-auto px-6 py-20 text-center">
        {status === 'checking' && (
          <div data-testid="billing-checking">
            <Loader2 className="w-12 h-12 text-emerald-400 animate-spin mx-auto mb-4" />
            <h1 className="text-xl font-bold mb-2">Processing Payment...</h1>
            <p className="text-[hsl(var(--muted-foreground))]">Verifying your payment with Stripe</p>
          </div>
        )}
        {status === 'success' && (
          <div data-testid="billing-success">
            <CheckCircle className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold mb-2">Welcome to Pro!</h1>
            <p className="text-[hsl(var(--muted-foreground))] mb-6">
              Your ${paymentData?.amount || 49}/mo subscription is now active.
            </p>
            <div className="space-y-3">
              <Link to="/dashboard" className="block px-6 py-3 rounded-lg bg-emerald-500 text-white font-medium hover:bg-emerald-600 transition-colors">
                Go to Dashboard
              </Link>
              <Link to="/" className="block text-sm text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]">
                Back to Home
              </Link>
            </div>
          </div>
        )}
        {(status === 'error' || status === 'expired' || status === 'timeout') && (
          <div data-testid="billing-error">
            <XCircle className="w-14 h-14 text-red-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold mb-2">
              {status === 'expired' ? 'Session Expired' : 'Payment Issue'}
            </h1>
            <p className="text-[hsl(var(--muted-foreground))] mb-6">
              {status === 'expired' ? 'Your checkout session expired. Please try again.' : 'We couldn\'t verify your payment. Please contact support.'}
            </p>
            <Link to="/pricing" className="px-6 py-3 rounded-lg bg-emerald-500 text-white font-medium hover:bg-emerald-600 transition-colors">
              Try Again
            </Link>
          </div>
        )}
      </main>
    </div>
  );
}
